
export const uiElementsStatesMap = {
    AutoplayStopUIState : {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: true,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    },
    AutoplaySpinUIState : {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: false,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    },
    AutoplayStartUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: false,
        turbo_btn_disabled: false,
        auto_btn_disabled: false,
        home_btn_disabled: false,
        fullscreen_btn_disabled: false,
        bet_panel_disabled: true,
    },
    BuyFeaturePopUpUIState: {
        sound_btn_disabled: true,
        menu_btn_disabled: true,
        turbo_btn_disabled: true,
        auto_btn_disabled: true,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    },
    FreeGameUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: true,
        home_btn_disabled: false,
        fullscreen_btn_disabled: false,
        bet_panel_disabled: true,
    },
    DisabledUIState: {
        sound_btn_disabled: true,
        menu_btn_disabled: true,
        turbo_btn_disabled: true,
        auto_btn_disabled: true,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    },
    IdleUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: false,
        turbo_btn_disabled: false,
        auto_btn_disabled: false,
        home_btn_disabled: false,
        fullscreen_btn_disabled: false,
        bet_panel_disabled: false,
    },
    RespinUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: true,
        home_btn_disabled: false,
        fullscreen_btn_disabled: false,
        bet_panel_disabled: true,
    },
    SpinningUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: true,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    },
    PickBonusUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: true,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    },
    HoldForTurboUIState: {
        sound_btn_disabled: false,
        menu_btn_disabled: true,
        turbo_btn_disabled: false,
        auto_btn_disabled: true,
        home_btn_disabled: true,
        fullscreen_btn_disabled: true,
        bet_panel_disabled: true,
    }
} as const;

// Extract the state name keys
export type UIStateName = keyof typeof uiElementsStatesMap;

// Extract the state structure
export type UIStateStoreType = typeof uiElementsStatesMap[UIStateName];

// Extract the button keys dynamically
export type UIButtonKey = keyof UIStateStoreType;